import firebase from "firebase/compat";

import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { getFinalList } from "../../../utils/collectionQuery";
import firebaseApp, { firestore } from "../../firebase";
import { store } from "../../../root/ReduxConfig";
import { applyCreateTimestamp, applyUpdateTimestamp } from "../../../utils/timestamp";
import { prepareDataUploads } from "../../utils/prepareData";
import { fileUploader } from "../../utils/upload";
import { deleteFiles } from "../../utils/deleteFiles";
import { Timestamp } from "firebase/firestore";

const entertainmentServicesResource = {
  [AppResource.entertainmentServices]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      return getFinalList(
        {
          ...params,
          limit: params.pagination.perPage,
        },
        firestore
          .collection(AppResource.entertainments)
          .doc(params.user.id)
          .collection(AppResource.services)
          .where("type", "==", "entertainment")
      );
    },

    [DataProviderKey.getOne]: async (_: any, params: { id: string }) => {
      const snapshot = await firestore
        .collection(AppResource.entertainments)
        .doc(store.getState().user.id)
        .collection(AppResource.services)
        .doc(params.id)
        .get();

      return {
        data: {
          ...snapshot.data(),
          id: snapshot.id,
        },
      };
    },

    [DataProviderKey.create]: async (resource: string, params: any) => {
      const preparedUploads = prepareDataUploads(params.data.values);
      const uploadedData: any = await fileUploader({
        fileUploaderData: { originalData: params.data.values, resource, uploads: preparedUploads },
        storage: firebaseApp.storage(),
      });

      try {
        const snapshot = await firestore
          .collection(AppResource.entertainments)
          .doc(store.getState().user.id)
          .collection(AppResource.services)
          .add(
            applyCreateTimestamp({
              ...uploadedData.dataWithUploadedFiles,
              from: new Date(uploadedData.dataWithUploadedFiles.from),
              to: new Date(uploadedData.dataWithUploadedFiles.to),
              status: "active",
              ...(uploadedData.dataWithUploadedFiles.limit ? { limit: uploadedData.dataWithUploadedFiles.limit } : {}),
            })
          );

        return { data: { id: snapshot.id } };
      } catch (ex: any) {
        console.log(ex);
        // delete uploaded files
        await deleteFiles({ fileRefs: uploadedData.uploadedRefs! });
        throw new Error(ex);
      }
    },

    [DataProviderKey.update]: async (resource: string, params: any) => {
      const { id, ...overriddenValues } = params.data.values;

      const preparedUploads = prepareDataUploads(overriddenValues);
      const uploadedData = await fileUploader({
        fileUploaderData: { originalData: overriddenValues, resource, uploads: preparedUploads },
        storage: firebaseApp.storage(),
      });

      try {
        await firestore
          .collection(AppResource.entertainments)
          .doc(store.getState().user.id)
          .collection(AppResource.services)
          .doc(id)
          .update(
            applyUpdateTimestamp({
              ...uploadedData.dataWithUploadedFiles,
              ...(typeof uploadedData.dataWithUploadedFiles?.from === "string"
                ? { from: new Date(uploadedData.dataWithUploadedFiles?.from) }
                : {}),
              ...(typeof uploadedData.dataWithUploadedFiles?.to === "string"
                ? { to: new Date(uploadedData.dataWithUploadedFiles?.to) }
                : {}),
            })
          );

        return { data: { id: id, ...uploadedData.dataWithUploadedFiles! } };
      } catch (ex: any) {
        console.log(ex);
        // delete uploaded files
        await deleteFiles({ fileRefs: uploadedData.uploadedRefs! });
        throw new Error(ex);
      }
    },
  },
};

export default entertainmentServicesResource;
